module.exports = __webpack_public_path__ + "static/media/clareador.e12eeeba.png";